import React from 'react';

import { ScanIqHeaderLogo } from '../ScanIqHeaderLogo/ScanIqHeaderLogo';
import { ReactComponent as LogoIcon } from '../../../assets/icons/logo.svg';
import { SOLUTION_TYPE, SolutionType } from '../../../constants/user-info/solutionType';
import { ChallengeHeaderLogo } from '../ChallengeHeaderLogo/ChallengeHeaderLogo';

type HeaderLogoProps = {
  solution?: SolutionType | null;
};

const HeaderLogo = ({ solution }: HeaderLogoProps) => {
  switch (solution) {
    case SOLUTION_TYPE.SCAN_IQ:
      return <ScanIqHeaderLogo />;
    case SOLUTION_TYPE.CHALLENGE:
      return <ChallengeHeaderLogo />;
    case SOLUTION_TYPE.NUTRITION:
    default:
      return <LogoIcon />;
  }
};

export { HeaderLogo };
